import CropYear from "domain/cropYear";
import cropYearsService from "./cropYears.service";
import Event from "common/event";
import { ActionWithDispatch } from "common/actionWithDispatch";

export class CropYearsLoaded extends Event {
    constructor(public cropYears: CropYear[]) {
        super(CropYearsLoaded.EventName);
    }

    public static EventName: string = "CROP_YEARS_LOADED";
}

export function loadCropYears(): ActionWithDispatch<Promise<CropYear[]>> {
    return function (dispatch: any) {
        return cropYearsService
            .listCropYears()
            .then(cropYears => dispatch(new CropYearsLoaded(cropYears).toObject()));
    };
}